import TaskError from '@/common/utils/errors/TaskError';
import socketio from '@/common/utils/socketio.connection';
import { TaskState } from '@schema';

export default function waitABGWTask({ id = '', success = TaskState.SUCCESS, failed = TaskState.FAILED }): Promise<{ id: string }> {
  return new Promise(((resolve, reject) => {
    const callback = function (taskResponse) {
      if (taskResponse.id === id) {
        switch (taskResponse.status) {
          case success:
            socketio.off('abgw', callback);
            resolve(taskResponse);
            break;
          case failed:
            socketio.off('abgw', callback);
            reject(new TaskError(taskResponse));
            break;
          default:
            break;
        }
      }
    };

    socketio.on('abgw', callback);
  }));
}
